type ScreenshotProps = {
    src: string
    label: string
}

const screenshotFolder = "/img/screenshots/"

const Screenshot = ({ src, label }: ScreenshotProps) => <figure className="screenshot">
    <figcaption>{label}</figcaption>
    <img src={`${screenshotFolder}${src}`}/>
</figure>

type ScreenshotRefProps = {
    label: string
}

export const ScreenshotRef = ({ label }: ScreenshotRefProps) => <span className="screenshot-ref">(Figure {label})</span>

export default Screenshot